import Api from 'services/api'

const LOAN_SCOPED_PATH_PREFIXES = [
  '/loan_process/',
  '/servicing/',
  '/pool/',
  '/nexys-shared/',
  '/reo/',
  '/budget/',
  '/underwriting/',
  '/loanInTake/',
  '/bytepro_logs/',
  '/loan_change_request/',
  '/post_closing/',
  '/closing_calendar/',
  '/closing_screen/',
  '/fee_worksheet/',
  '/amortization_schedule/',
  '/order_valuation/',
  '/document_genie/',
  '/review_form/',
  '/appraisal_information/',
  '/reminders/',
  '/expiration_dates/',
  '/notes/',
  '/dataverify/',
  '/underwriting_summary/',
  '/purchase_advice/',
  '/purchase_advice_seller/',
  '/secondary_marketing_screen/',
  '/national_flood/',
  '/loan_ai_project/',
  '/tasks/loan/',
]

export const isLoanScopedPath = (pathname: string) =>
  LOAN_SCOPED_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))

/** After impersonation, open the borrower portal for a borrower session, otherwise stay unless the page is loan-scoped. */
export const redirectAfterImpersonationIfNeeded = (
  history: {
    location: { pathname: string }
    push: (path: string) => void
  },
  user?: { isBorrower?: boolean; temparary?: boolean },
) => {
  Api.setLoanNumber('')
  if (user?.isBorrower || user?.temparary) {
    history.push('/borrowerPipelines')
    return
  }
  const path = history.location.pathname
  if (isLoanScopedPath(path) || path.startsWith('/borrower')) {
    history.push('/pipeline')
  }
}
